import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { appRoutes, RouteConfig, BASE_URL } from './routes';
import { notFoundRouteRenderer } from './components/page/routes';

export default () => {
    return (
        <BrowserRouter basename={BASE_URL}>
            <Switch>
                {appRoutes.map(renderRoute)}

                {/* not found */}
                <Route render={notFoundRouteRenderer} />
            </Switch>
        </BrowserRouter>
    );
};

const renderRoute = (routeConfig: RouteConfig) => {
    return (
        <Route
            exact={routeConfig.isExact}
            key={routeConfig.path}
            path={routeConfig.path}
            render={routeConfig.renderer}
        />
    );
};
